export default "__VITE_ASSET__CQvt$8gh__"